import * as icons from 'core/icons';

const seguimiento = {
    id: 'seguimiento',
    title: 'Seguimiento',
    //caption:'Este es el caption',
    type: 'group',
    visible: true,
    children: [
        {
            id: 'dashboard',
            title: 'Cuadro Mandos',
            type: 'item',
            url: '/seguimiento/dashboard',
            visible: true,
            icon: icons.DashboardIcon,
            breadcrumbs: false
        },
        {
            id: 'acercade',
            title: 'Acerca de',
            type: 'item',
            url: '/acercade',
            visible: true,
            icon: icons.AcercaDeIcon,
            breadcrumbs: false
        },
        {
            id: 'wsreto',
            title: 'Servicios RETO (MAPA)',
            type: 'item',
            url: '/servicios/wsreto',
            visible: true,
            icon: icons.ApiExternaIcon,
            breadcrumbs: false
        }
        /*{
            id: 'informes',
            title: 'Informes',
            type: 'item', //'collapse',
            url: '/seguimiento/informes',
            icon: icons.InformesIcon,
            visible: true,
            breadcrumbs: false
        },
        {
            id: 'tablero',
            title: 'Tablero',
            type: 'item',
            url: '/seguimiento/tablero',
            visible: true,
            icon: icons.TableroIcon,
            breadcrumbs: false
        },
        {
            id: 'validar',
            title: 'Validar',
            type: 'item',
            url: '/seguimiento/validar',
            visible: true,
            icon: icons.ToVerifiedIcon,
            breadcrumbs: false
        },
        {
            id: 'tareas',
            title: 'Tareas',
            type: 'item',
            url: '/seguimiento/tareas',
            visible: true,
            icon: icons.TareasIcon,
            breadcrumbs: false
        }*/
    ]
};

export default seguimiento;
